import { useState, useEffect } from 'react';

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      url: 'https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/6903188c6bdd41a397ae730251eefe26.jpeg',
      alt: 'Glaciar patagónico con lago turquesa'
    },
    {
      url: 'https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/8f8687353579e19b7978129217f486b4.jpeg',
      alt: 'Casona patagónica con montañas'
    },
    {
      url: 'https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/8845abc014f6634e4a0c68a427cf3460.jpeg',
      alt: 'Glaciar Serrano con lago y montañas'
    },
    {
      url: 'https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/6903188c6bdd41a397ae730251eefe26.jpeg',
      alt: 'Glaciar patagónico con lago turquesa'
    },
    {
      url: 'https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/dc134ccefcb6b246157676aca096e4f9.jpeg',
      alt: 'Paisaje patagónico con montañas'
    },
    {
      url: 'https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/0a8ebe4c55c97599cc5b94af390fc163.jpeg',
      alt: 'Torres del Paine con niebla y amanecer'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const scrollToSection = (id: string) => {
    const element = document.querySelector(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Carousel Background */}
      <div className="absolute inset-0 w-full h-full">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 w-full h-full transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={slide.url}
              alt={slide.alt}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Carousel Indicators */}
      <div className="absolute bottom-24 left-1/2 -translate-x-1/2 z-20 flex gap-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              index === currentSlide
                ? 'bg-white w-8'
                : 'bg-white/50 hover:bg-white/75'
            }`}
            aria-label={`Ir a imagen ${index + 1}`}
          />
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-32">
        <div className="inline-flex items-center gap-2 bg-emerald-700/90 text-white px-4 py-2 rounded-full text-sm font-medium mb-6 backdrop-blur-sm">
          <i className="ri-map-pin-line"></i>
          Coyhaique · Patagonia Chilena
        </div>

        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Cafetería Boutique en la Patagonia
        </h1>

        <p className="text-lg sm:text-xl text-white/95 mb-10 max-w-3xl mx-auto leading-relaxed">
          Café de especialidad y una vitrina de ropa seleccionada dentro del local.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </div>
      </div>
    </section>
  );
}
